<template>
  <div class="stepper">
    <el-button
      type="text"
      icon="el-icon-remove-outline"
      circle
      v-if="!isZero()"
      @click="cmd0"
    />

    <span class="qty" v-if="!isZero()">{{ Number(s2.Qty) }}</span>
    <!-- {{ s2 }} -->

    <el-button
      type="text"
      icon="el-icon-circle-plus-outline"
      circle
      @click="cmd1"
      :disabled="isStopSale(s2.ItemName) || disableQty()"
    />

    <span v-bind:class="sGetConfig('chkMenuFontSizeLarge') ? 'fx12' : ''">
      {{ s2.DispName }}
      <span class="C1" v-if="s2.Price1 != 0"> +${{ s2.Price1 }}</span>
      <span v-if="isStopSale(s2.ItemName)"> 售完</span>
    </span>
  </div>
</template>

<style scoped>
.stepper {
  min-height: 3rem;
}
.qty {
  font-size: 1.4rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.el-button {
  margin: 0;
  padding: 0;
  font-size: 1.4rem;
  line-height: 3rem;
  color: v-bind(sGetConfig("color2"));
}
</style>

<script>
var fits = require("../../../../mixin/lib-fits-front");
export default {
  props: {
    s2: Object,
    maxQty: String || Number,
  },
  methods: {
    onChange() {
      this.$emit("change", this.s2);
    },
    isZero() {
      if (this.s2.Qty < 1) {
        return true;
      }
      return false;
    },
    cmd0() {
      this.s2.Qty--;
      this.onChange();
    },
    cmd1() {
      this.s2.Qty++;
      this.onChange();
    },
    isStopSale(itemname) {
      const find = this.$store.state.sStopSale.find((r) => r.ItemName == itemname);
      return find;
    },
    disableQty() {
      let maxQty = this.maxQty;
      if (maxQty) maxQty = fits.val(maxQty);
      if (maxQty == 0) return false;
      if (this.s2.Qty >= maxQty) return true;
      return false;
    },
  },
};
</script>
